/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["@media (min-width:768px){div.box[_ngcontent-%COMP%], section.box[_ngcontent-%COMP%]{margin:10px 0;border:1px solid #ccc;padding:0 20px 10px;border-radius:5px}}"];
export { styles as styles };
